export default __webpack_public_path__ + "fc462e57a0cd6b39d3a5cc29e267dde9.png";